import { render, staticRenderFns } from "./AddSalaries.vue?vue&type=template&id=aad5abc0"
import script from "./AddSalaries.vue?vue&type=script&lang=js"
export * from "./AddSalaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports